export class FieldErrorValidator {
    constructor(validators) {
        this.validators = validators;
    }
    validate(value) {
        for (let i = 0; i < this.validators.length; i++) {
            if (!this.validators[i].validate(value)) {
                return this.validators[i].message;
            }
        }
        return undefined;
    }
}
//# sourceMappingURL=FieldErrorValidator.js.map